import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import LoadMoreComments from "./loadMoreComments";
import Et3Table from "../../../../../core/et3-table";
import React from "react";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import { USER_ADMIN_COMMENTS_HEADERS } from "../../../../../constants/table-custom-headers/User";
import i18n from "../../../../../constants/i18n";

const UserCommentsTable = withLiteObserverAndTheme(() => {
  const commentsArray = getUserAdvancedStore().getNewAddedComment.get();
  const showComments = getUserAdvancedStore().showComments.get();
  const commentExist = getUserAdvancedStore().ifCommentsExist.get();

  return commentExist && showComments ? (
    <React.Fragment>
      <Et3Table
        columns={USER_ADMIN_COMMENTS_HEADERS}
        rows={commentsArray}
        title={i18n.get("COMMENTS")}
        shouldBeFlagged={false}
        titleKey={"COMMENTS"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <LoadMoreComments />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
    </React.Fragment>
  ) : null;
});
export default UserCommentsTable;
